import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useReactHeader } from "../../hooks/useReactHeader";
import { isUserAdmin } from "../../../core/user-management/update.control";
import api from "../../../core/api/api";
import ALERT_MANAGER_ROUTES from "./routes.json";
import AlertManagerRoot from "./alert-manager-root";
import LoadingIndicator from "../../generic/loading-indicator/loading-indicator";

function AlertManager() {
    const isAdmin = isUserAdmin();
    useReactHeader({ title: "Alert Manager" });
    const navigate = useNavigate();

    useEffect(() => {
        api.hasAlertAppBeenCreated()
            .done(hasAlertAppBeenCreated => {
                if (!hasAlertAppBeenCreated) {
                    if (isAdmin) {
                        navigate(ALERT_MANAGER_ROUTES.setupSMTP);
                    } else {
                        navigate(`${ALERT_MANAGER_ROUTES.alertmanager}/view/apps`);
                    }
                } else {
                    navigate(`${ALERT_MANAGER_ROUTES.alertmanager}/view/${isAdmin ? "smart_alerts" : "apps"}`);
                }
            })
            .fail(() => {
                if (isAdmin) {
                    navigate(ALERT_MANAGER_ROUTES.unauthorized);
                } else {
                    navigate(`${ALERT_MANAGER_ROUTES.alertmanager}/view/apps`);
                }
            });
    }, []);

    return <LoadingIndicator />;
}

export default function() {
    return (
        <AlertManagerRoot>
            <AlertManager />
        </AlertManagerRoot>
    );
}
